import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';
import { PurchaseType, purchaseTypes } from '../constants/propertyForm';

export const PurchaseTypeField = () => {
    const value = useWizardDemoStore((state) => state.property.purchaseType);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <DropDownBox
            id='propertyPurchaseType'
            value={value || null}
            onChange={(type: PurchaseType | null) => updateProperty({ purchaseType: type ?? '' })}
            label='Purchase Type'
            required={true}
            width={'100%'}
            dataSource={purchaseTypes}
            placeholder='Select'
            searchEnabled={false}
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
